// extracted by mini-css-extract-plugin
export default {"Pagination":"index__Pagination__uSKKp"};